import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-md-12 text-center my-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " No Contribution Details Available ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "table table-bordered table-striped",
  id: "detail_table",
  style: {"max-height":"300px"}
}
const _hoisted_5 = { class: "table-dark" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "Totals:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableRow = _resolveComponent("TableRow")!

  return (_ctx.PWHDs.length == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("table", _hoisted_4, [
        _createElementVNode("thead", _hoisted_5, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.headerNames), (header, key) => {
              return (_openBlock(), _createElementBlock("th", {
                key: key,
                onClick: ($event: any) => (_ctx.sortBy(header[0])),
                style: { cursor: 'pointer' }
              }, _toDisplayString(header[1]), 9, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PWHDs, (PWHD) => {
            return (_openBlock(), _createBlock(_component_TableRow, {
              key: PWHD.ParticipantWHID,
              PWHD: PWHD
            }, null, 8, ["PWHD"]))
          }), 128))
        ]),
        _createElementVNode("tfoot", null, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.totalDaysWorked), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.totalContributions?.toFixed(2)), 1),
            _hoisted_8
          ])
        ])
      ]))
}